import request from "superagent";

import { getTabToken } from "common/MetaActions";
import config from "config/config";
import {
  assignmentManagerGetCommitments,
  getOffices,
  gettingAssignmentManagerList,
  gettingCommitments,
  gettingOffices,
  gettingResults,
  setAssignmentManagerList,
  setResults
} from "./Actions";
import { useRootStore } from "store";

const { appendErrorNotification } = useRootStore.getState().error;

export function fetchOffices() {
  return async (dispatch) => {
    dispatch(gettingOffices(true));

    try {
      return new Promise((resolve, reject) => {
        request
          .get(config.api.invoices.offices.get)
          .set("Accept", "application/json")
          .set("Authorization", "Bearer " + getTabToken())
          .end((err, res) => {
            err ? reject({ err, res }) : resolve(res);
          });
      })
        .then((result) => {
          let model = JSON.parse(result.text);
          dispatch(getOffices(model));
          dispatch(gettingOffices(false));
        })
        .catch((error) => {
          appendErrorNotification("Failed to fetch offices", error);
          dispatch(gettingOffices(false));
        });
    } catch (error) {
      appendErrorNotification("Failed to fetch offices", error);
      dispatch(gettingOffices(false));
    }
  };
}

export function getAssignmentManagerList(office) {
  return async (dispatch) => {
    dispatch(gettingAssignmentManagerList(true));

    try {
      return new Promise((resolve, reject) => {
        request
          .get(
            config.api.invoices.assignmentManager.getAssignmentManagers(
              office.name
            )
          )
          .set("Accept", "application/json")
          .set("Authorization", "Bearer " + getTabToken())
          .end((err, res) => {
            err ? reject({ err, res }) : resolve(res);
          });
      })
        .then((result) => {
          let model = JSON.parse(result.text);
          dispatch(setAssignmentManagerList(model));
          dispatch(gettingAssignmentManagerList(false));
        })
        .catch((result) => {
          appendErrorNotification(
            "Failed to fetch assignment manager list",
            result
          );
        });
    } catch (error) {
      appendErrorNotification("Failed to fetch assignment manager list", error);
    }
  };
}

// Gets ua's commitments from api using ua's locally stored id
export function getCommitmentsByAssignmentManagerId(assignmentManagerId) {
  return async (dispatch) => {
    dispatch(gettingCommitments(true));

    try {
      return new Promise((resolve, reject) => {
        request
          .get(
            config.api.invoices.assignmentManager.getCommitments(
              assignmentManagerId
            )
          )
          .set("Accept", "application/json")
          .set("Authorization", "Bearer " + getTabToken())
          .end((err, res) => {
            err ? reject({ err, res }) : resolve(res);
          });
      })
        .then((result) => {
          let model = JSON.parse(result.text);
          model.length > 0
            ? dispatch(assignmentManagerGetCommitments(model))
            : appendErrorNotification("Got 0 commitments", {});
          dispatch(gettingCommitments(false));
        })
        .catch((result) => {
          appendErrorNotification("Failed to fetch commitments", result);
        });
    } catch (error) {
      appendErrorNotification("Failed to fetch commitments", error);
    }
  };
}

export function getResultStatistics(office) {
  return async (dispatch) => {
    try {
      return new Promise((resolve, reject) => {
        dispatch(gettingResults(true));

        request
          .get(config.api.invoices.resultStatistics.get(office.name))
          .set("Accept", "application/json")
          .set("Authorization", "Bearer " + getTabToken())
          .end((err, res) => {
            err ? reject({ err, res }) : resolve(res);
          });
      })
        .then((result) => {
          let model = JSON.parse(result.text);
          dispatch(setResults(model));
          dispatch(gettingResults(false));
        })
        .catch((err) => {
          appendErrorNotification("Failed to fetch result statistics", err);
          dispatch(gettingResults(false));
        });
    } catch (error) {
      appendErrorNotification("Failed to fetch result statistics", error);
      dispatch(gettingResults(false));
    }
  };
}

export function getVolumeAnalysis(customerId, setVolumeAnalysisCallback) {
  return async (dispatch) => {
    try {
      return new Promise((resolve, reject) => {
        request
          .get(config.api.volumeAnalysis.get(customerId))
          .set("Accept", "application/json")
          .set("Authorization", "Bearer " + getTabToken())
          .end((err, res) => {
            err ? reject({ err, res }) : resolve(res);
          });
      })
        .then((response) => {
          setVolumeAnalysisCallback(response.body);
        })
        .catch((error) => {
          appendErrorNotification("Failed to fetch volume analysis", error);
        });
    } catch (error) {
      appendErrorNotification("Failed to fetch volume analysis", error);
      dispatch(gettingResults(false));
    }
  };
}
